var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23915 3.04297L5.27774 0.725348C4.58029 -0.0987607 3.3361 -0.235993 2.58612 0.540605C0.713154 2.48003 0.0936559 4.44299 0.326906 6.70429C0.683325 10.1597 7.82196 17.8774 10.9779 19.7037C13.0234 20.8874 15.792 19.7933 17.8295 18.1811C18.6198 17.5558 18.6345 16.4081 17.9835 15.6389L15.9574 13.2448C15.1964 12.3456 13.8559 12.334 12.9208 13.0505C12.0047 13.7526 11.2442 14.0203 10.4742 13.8087C8.99976 13.4037 5.83294 9.81556 5.82177 8.05381C5.81649 7.22229 6.26267 6.58529 6.93937 5.97048C7.79141 5.19638 7.98281 3.9217 7.23915 3.04297Z",
    fill: "#EE4D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipPhone);
export default __webpack_public_path__ + "static/media/tooltipPhone.ff377f6aac5f2467c5abe44ac62742d0.svg";
export { ForwardRef as ReactComponent };